module.exports = __webpack_public_path__ + "img/resources-1440.f7dd828c.jpg";